import type { GetExploreContent200PageAllOfThreeContentItemContentOneOf } from './getExploreContent200PageAllOfThreeContentItemContentOneOf';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfThreeseven } from './getExploreContent200PageAllOfThreeContentItemContentOneOfThreeseven';
import type { GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezero } from './getExploreContent200PageAllOfThreeContentItemContentOneOfFivezero';

/**
 * 콘텐츠 데이터 (타입에 따라 다른 형식)
 */
export type GetExploreContent200PageAllOfThreeContentItemContent = GetExploreContent200PageAllOfThreeContentItemContentOneOf | GetExploreContent200PageAllOfThreeContentItemContentOneOfThreeseven | GetExploreContent200PageAllOfThreeContentItemContentOneOfFivezero;
